<div class="ffd-notes-invite-welcome-container flex flex-col overflow-y-auto sm:overflow-hidden">
  <div class="container mt-3 flex items-center justify-center px-10">
    <img class="h-[48px]" src="assets/images/notes-logo-header.svg" height="48" alt="FFD Notes" />
  </div>

  <div class="mb-6 flex flex-col xs:h-full xs:items-center xs:justify-center">
    <div class="mx-4 mt-8 flex flex-col rounded-[26px] bg-background-white p-6 shadow-lg xs:mx-0 xs:mt-0 xs:w-[540px] xs:p-12">
      @if (isLoadingSignal()) {
        <ng-lottie [options]="lottieOptions" currentColor class="self-center text-primary-blue" />
      } @else if (resolutionSignal(); as resolution) {
        <h2 class="typo-h2 text-text-primary">
          {{ 'ffd_notes_invitation_title' | translate: { input1: resolution.inviterName, input2: resolution.siteName } }}
        </h2>

        <div class="mt-6 flex flex-col gap-3">
          <div class="flex items-center gap-2">
            <svg-icon key="px-16-check" size="md" class="shrink-0 text-primary-blue"></svg-icon>
            <p class="typo-h5-medium text-text-black">{{ 'ffd_notes_invitation_benefit1' | translate }}</p>
          </div>
          <div class="flex items-center gap-2">
            <svg-icon key="px-16-check" size="md" class="shrink-0 text-primary-blue"></svg-icon>
            <p class="typo-h5-medium text-text-black">{{ 'ffd_notes_invitation_benefit2' | translate }}</p>
          </div>
          <div class="flex items-center gap-2">
            <svg-icon key="px-16-check" size="md" class="shrink-0 text-primary-blue"></svg-icon>
            <p class="typo-h5-medium text-text-black">{{ 'ffd_notes_invitation_benefit3' | translate }}</p>
          </div>
        </div>

        <div class="mt-8">
          <button type="button" class="btn-primary w-full justify-center" (click)="onContinue()">
            {{ 'baa_signup_info_cta' | translate }}
          </button>
        </div>

        <hr class="my-4 h-[1px] w-full border-background-disabled" />

        <p class="typo-h5-extralight text-center text-text-primary">
          {{ 'baa_signup_info_already_have_account' | translate }}
          <a
            class="typo-h5-semibold text-primary-blue underline"
            [routerLink]="[...ffdNotesRoutePrefix(), routes.baaSignupFlow, routes.baaSignupLogin]"
            [queryParamsHandling]="'preserve'"
          >
            {{ 'baa_signup_info_log_in' | translate }}
          </a>
        </p>
      }
    </div>
  </div>
</div>
